import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { ClienteFinal } from "@/interfaces/user.interface";
import { LogoClienteFinal } from "@/components/ui/LogoClienteFinal";
import defaultLogo from "@/assets/default-logo.png";

export function DetalleClienteFinal({ data }: { data: ClienteFinal }) {
  const {
    nombreEmpresa,
    logoMarca,
    logoMarcaInverso,
    colorPrimario,
    colorSecundario,
    colorTextoPrimario,
    colorTerciario1,
    colorTerciario2,
    tipografiaMarca,
    usuario,
  } = data;
  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle className="text-lg font-semibold">
          Detalles del Cliente Final
        </CardTitle>
      </CardHeader>
      <CardContent className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
        <div>
          <span className="font-medium">Empresa:</span> {nombreEmpresa}
        </div>
        <div>
          <span className="font-medium">Tipografía:</span>{" "}
          {tipografiaMarca ?? "—"}
        </div>

        {[
          { label: "Logo", logo: logoMarca, fondo: "bg-white border-gray-200" },
          {
            label: "Logo inverso",
            logo: logoMarcaInverso,
            fondo: "bg-[#141821] border-[#2b313d]",
          },
        ].map(({ label, logo, fondo }) => (
          <div key={label} className="flex flex-col gap-1">
            <span className="font-medium">{label}:</span>
            {logo && (logo.llave || logo.url) ? (
              <div
                className={`flex h-16 items-center justify-center rounded-md border p-2 ${fondo}`}
              >
                <LogoClienteFinal
                  logoMarca={logo}
                  defaultSrc={defaultLogo}
                  alt={`${label} de ${nombreEmpresa}`}
                  className="max-h-full max-w-full object-contain"
                />
              </div>
            ) : (
              "—"
            )}
          </div>
        ))}

        {[
          { label: "Color primario", valor: colorPrimario },
          { label: "Color secundario", valor: colorSecundario },
          { label: "Color de texto primario", valor: colorTextoPrimario },
          { label: "Color terciario 1", valor: colorTerciario1 },
          { label: "Color terciario 2", valor: colorTerciario2 },
        ].map(({ label, valor }) => (
          <div key={label} className="flex items-center gap-2">
            <span className="font-medium">{label}:</span>
            {valor ? (
              <div
                className="w-5 h-5 rounded border"
                style={{ backgroundColor: valor }}
              />
            ) : (
              "—"
            )}
          </div>
        ))}
        <div className="spans col-span-2">
          <span className="font-medium">Activo:</span>{" "}
          {usuario.isActivo ? "Sí" : "No"}
        </div>
        <div className="border-t pt-4">
          <strong>Usuario Responsable:</strong>
          <div className="mt-2 space-y-1 ml-2">
            <div>
              <strong>Nombre:</strong> {usuario.nombre}{" "}
              {usuario.apellidoPaterno} {usuario.apellidoMaterno ?? ""}
            </div>
            <div>
              <strong>Correo:</strong> {usuario.correo}
            </div>
            <div>
              <strong>Rol:</strong> {usuario.rol?.nombre}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
